<template>
	<div class="body" v-loading="loading">
		<div class="top" v-show="contentshow">
			<img class="guohui" src="../assets/guohuizu.png" alt="" />
			<div class="tip-title">
				<span class="a-flex-center"
					><img class="img-22" src="../assets/copyright.png" alt="" />
					数据确权</span
				>
				<span class="a-flex-center"
					><img class="img-20" src="../assets/fachui.png" alt="" />
					可信固证</span
				>
				<span class="a-flex-center"
					><img class="img-18" src="../assets/tianpin.png" alt="" />
					BSN司法链</span
				>
			</div>
			<div class="tip">
				<span class="txt_bold">国家区块链</span>
				<span>＋</span>
				<span class="txt_bold">司法级存证</span>
			</div>
			<div class="quire">
				<div class="quire-item">
					<div class="quire_title">首次查询时间</div>
					<div class="quire_p">{{ data.scanDate }}</div>
				</div>
				<div class="quire-item">
					<div class="quire_title txt_center">首次查询地址</div>
					<div class="quire_p txt_center">{{ data.scanAddr }}</div>
				</div>
				<div class="quire-item" @click="nextScan(data.batchId)">
					<div class="quire_title txt_end">第n次扫码</div>
					<div class="quire_p txt_end">查看详情</div>
				</div>
			</div>
		</div>
		<div class="block" v-show="contentshow" @click="certificate(data)">
			<div class="block-item">
				<img src="../assets/bsn.png" alt="" />
				<span class="block-ctx">区块链标识:{{ data.blockId }}</span>
			</div>
			<span>＞</span>
		</div>

		<!-- tab框 -->

		<div class="new-list">
			<div class="tab" v-show="contentshow">
				<div class="tab-box">
					<div
						:class="[active === 1 ? 'active' : '', 'tab-box-item']"
						@click="tabClick(1)">
						<div class="tab-box-item-title">报告详情</div>
						<img
							v-if="active === 1"
							class="tab-img left"
							src="../assets//tab-img.png"
							alt="" />
					</div>
					<div
						:class="[active === 2 ? 'active' : '', 'tab-box-item']"
						@click="tabClick(2)">
						<div class="tab-box-item-title">二维码</div>
						<img
							v-if="active === 2"
							class="tab-img left del5"
							src="../assets//tab-img.png"
							alt="" />
						<img
							v-if="active === 2"
							class="tab-img right der5"
							src="../assets//tab-img.png"
							alt="" />
					</div>
					<div
						:class="[active === 3 ? 'active' : '', 'tab-box-item']"
						@click="tabClick(3)">
						<div class="tab-box-item-title">鉴定资质</div>
						<img
							v-if="active === 3"
							class="tab-img right"
							src="../assets//tab-img.png"
							alt="" />
					</div>
				</div>
			</div>
			<!-- v-if="active === 1" -->
			<div style="padding: 15px">
				<div v-if="active === 2" class="qrcode">
					<div class="new-list-tips">
						<img
							src="../assets/sifa1.png"
							style="width: 20px; height: 20px"
							alt="" />
						{{ data.brandName }}
					</div>
					<div>
						<van-loading v-if="qrURL==='' "></van-loading>
						<img v-else :src="qrURL" alt="" />
					</div>
					<div>
						微信扫码查看
					</div>
				</div>
				<div v-if="active === 1">
					<div class="new-list-tips">
						<img
							src="../assets/sifa1.png"
							style="width: 20px; height: 20px"
							alt="" />
						{{ data.brandName }}
					</div>
					<div class="new-list-box">
						<div class="btm_line" v-if="false">
							<div>
								<span class="new-list-title">品名：</span
								><span style="font-size: 13px">{{ data.proName }}</span>
							</div>
							<div>
								<span
									class="new-list-title"
									v-if="data.spec != '' && data.spec != null"
									>规格：</span
								><span style="font-size: 12px">{{ data.spec || "FZJL" }}</span>
							</div>
						</div>
						<div
							class="btm_line"
							v-for="(item, index) in data.traceList"
							:key="index + '1'">
							<div class="new-list-title">{{ item.traceName }}：</div>
							<div class="new-list-ctx" v-for="(list, index) in item.nodeList">
								<div v-if="list.dtlType == '1'">
									<el-image
										:src="changeUrl(list.dtlContent)"
										alt=""
										style="width: 100; height: 100%"
										:preview-src-list="list.urlList"></el-image>
								</div>
								<div v-else-if="list.dtlType == '2'">
									<Video :videoUrl="changeUrl(list.dtlContent)" />
								</div>
								<div
									v-else-if="list.dtlType == '3'"
									@click="imgClick(list.urlList[0])">
									<div>{{ list.dtlTitle }}</div>
									<el-image
										:src="changeUrl(list.dtlContent)"
										style="width: 100; height: 100%">
										<div slot="error" class="image-slot">
											<p class="new-list-title">( {{ list.dtlTitle }}.pdf )</p>
										</div>
									</el-image>
								</div>
								<div v-else class="new-list-item-ctx">
									<span>{{ list.dtlTitle }} </span>
									<span
										v-if="item.traceName !== '存证时间'"
										class="new-list-title"
										>{{ changeUrl(list.dtlContent) }}</span
									>
									<div v-else class="new-list-title" style="font-size: 12px">
										国家授时中心(NTSC)提供的可信时间戳服务(TSA)
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="active===3" class="zizhi">
					<div class="comp">
						<div>
							<span class="txt_bold txt_black">出证服务方：</span>
							<span>浙江易网科技股份有限公司</span>
						</div>
						<p class="txt_p">浙江易网科技股份有限公司成立于2006年5月，是国内同时获得最高人民法院电子证据备案入库资质、司法鉴定许可证授权、浙江省高级人民法院审核与备案。</p>
					</div>
					<div class="imgs">
						<img src="../assets//zizhi.png" style="width: 48%;" alt="">
						<div class="imgs-right">
							<div class="txt_p">构建了司鉴统一服务平台，整合了近百个权威鉴定机构,具备出具法庭认可的电子数据司法鉴定报告的能力。</div>
							<div class="txt_bold txt_black">资质查询：</div>
							<div>
								<div class="txt_p">人民法院诉讼资产网</div>
								<a class="txt_p" href="https://www.rmfysszc.gov.cn">https://www.rmfysszc.gov.cn</a>
							</div>
						</div>
					</div>
					<div>
						<Video :videoUrl="cvideoUrl"></Video>
					</div>
					<div class="bsn" style="color: #000;">
						资质查询完整视频引导
					</div>
				</div>
			</div>
		</div>

		<div class="bsn">BSN官方技术支持</div>

		<van-button
			v-if="data.codeSum && data.codeSum != 0"
			style="width: 100%; background-color: darkorange; color: #fff"
			round
			@click="handleCheckJump"
			>防伪查询</van-button
		>
	</div>
</template>
<script>
import { Notify } from "vant";
import Video from "@/components/video.vue";
import QrCode from "qrcode";
export default {
	components: {
		Video,
	},
	mounted() {
		this.batchId =
			this.getQueryString("batchId") != null
				? this.getQueryString("batchId")
				: localStorage.getItem("batchId");
		// this.map()
		this.fixedPos();
		const body = document.getElementsByTagName("body")[0];
		window.addEventListener("popstate", () => {
			body.style = "";
		});
		this.getQrCode()
	},
	data() {
		return {
			batchId: "",
			lng: String,
			lat: String,
			data: Object,
			loading: false,
			contentshow: true,
			active: 1,
			qrURL: "",
			cvideoUrl: "https://file.fzl.org.cn/1734_1749021037_raw.mp4",
		};
	},
	methods: {
		map() {
			if (localStorage.getItem("lng")) {
				this.lng = localStorage.getItem("lng");
				this.lat = localStorage.getItem("lat");
				this.fixedPos();
			} else {
				var geolocation = new qq.maps.Geolocation(
					"GFNBZ-GX6L2-GH4UU-C4OHK-YBIUT-FSFXJ",
					"trace"
				);
				console.log(geolocation, "qq.map.geolocation，实例化定位");
				geolocation.getIpLocation(
					(res) => {
						console.log(res, "获取定位成功时");
						this.lng = res.lng;
						this.lat = res.lat;
						localStorage.setItem("lng", res.lng);
						localStorage.setItem("lat", res.lat);
						this.fixedPos();
					},
					(err) => {
						this.fixedPos();
					}
				);
			}
		},
		getQrCode() {
			try {
				let that = this
				QrCode.toDataURL(
					location.origin + location.search
				).then(url=>{
					that.qrURL = url
				}).catch(err=>{
					console.log(err);
				})
			} catch(err) {
					console.log(err);
				
			}
		},
		tabClick(val) {
			this.active = val;
		},
		// PDF
		imgClick(e) {
			location.href = e;
		},
		fixedPos() {
			// 获取定位
			this.$axios
				.get(
					"/show/index?batchId=" +
						(this.batchId
							? this.batchId
							: localStorage.getItem("batchId") +
							  "&lng=120.13026" +
							  "&lat=30.25961")
				)
				.then((res) => {
					if (res.data.retCode == "9999") {
						this.contentshow = false;
						Notify({ type: "warning", message: res.data.retMsg });
					} else {
						this.data = res.data.retData;
					}
					this.loading = false;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		nextScan(e) {
			this.$router.push({ name: "scan", params: { id: e } });
		},
		certificate(e) {
			this.$router.push({ name: "certificate", params: { data: e } });
		},
		changeUrl(url) {
			let rgx = /^\d+$/;
			let idcard =
				/^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/;
			if (idcard.test(url)) {
				return `(${
					url.slice(0, 1) +
					"***************" +
					url.slice(6, 14) +
					"*******" +
					url.slice(-1)
				})`;
			}
			if (rgx.test(url)) {
				return `(${url.slice(0, 2) + "*******" + url.slice(-4)})`;
			}
			return url;
		},
		handleCheckJump() {
			let batchId = localStorage.getItem("batchId");
			let isIndex = localStorage.getItem("indexNo");
			this.$router.push({
				name: "check",
				query: {
					batchId,
					noIndex: isIndex && isIndex != "" ? false : true,
				},
			});
		},
		getQueryString(name) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
			var r = window.location.search.substring(1).match(reg);
			if (r != null) {
				localStorage.setItem("batchId", decodeURI(r[2]));
				return decodeURI(r[2]);
			}
			return null;
		},
	},
};
</script>
<style scoped>
.body {
	background: #f8f8f8;
	padding-bottom: 20px;
}
.top {
	/* background-image: url("../assets/bg.png"); */
	background-color: #01239d;
	height: 55vh;
}
.tip {
	position: absolute;
	top: 34vh;
	background-color: #ff4647;
	border-radius: 30px;
	color: #fff;
	font-weight: 500;
	width: 50%;
	left: 0;
	right: 0;
	margin: 0 auto;
	height: 40px;
	display: flex;
	justify-content: space-around;
	padding: 0 20px;
	align-items: center;
}
.tip-title {
	color: #fff;
	position: absolute;
	top: 29vh;
	width: 70%;
	font-size: 14px;
	margin: 0 auto;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: space-around;
}
.img-22 {
	width: 20px;
	padding-top: 2px;
	height: 22px;
	padding-right: 2px;
}
.img-20 {
	width: 20px;
	height: 20px;
	padding-right: 2px;
}
.img-18 {
	width: 18px;
	height: 16px;
	padding-right: 2px;
}

.list_title {
	background: #f0f7fe;
	border-radius: 12px 12px 0px 0px;
	height: 44px;
	line-height: 44px;
	margin-top: 14px;
	padding: 0 15px;
	margin-bottom: 15px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.quire {
	display: flex;
	justify-content: space-between;
	padding: 0 15px;
	font-size: 10px;
	position: absolute;
	top: 43vh;
	left: 0;
	right: 0;
}
.quire-item {
	width: 30%;
	display: flex;
	flex-direction: column;
	row-gap: 4px;
}
.quire_title {
	color: rgba(255, 255, 255, 0.6);
}
.quire_p {
	color: #fff;
}
.button {
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: rgba(7, 117, 241, 0.03);
	border: 1px solid #0775f1;
	border-radius: 34px;
	height: 34px;
	padding: 5px 15px;
	margin-top: 30px;
}
.list {
	margin: 0 15px;
	background: #fff;
	border-radius: 12px 12px 0px 0px;
	padding-bottom: 28px;
}
.dot {
	display: inline-block;
	width: 5px;
	height: 5px;
	background: #0775f1;
	border-radius: 50%;
	position: relative;
	left: -4px;
}
.li {
	display: flex;
	justify-content: space-between;
	margin: 0 15px;
	border-left: 1px dashed #0775f1;
}
.ui {
	display: flex;
	align-items: center;
}
.ui_title {
	color: #333333;
	margin-left: 5px;
}
.ui_p {
	color: #999999;
	width: 50%;
	word-break: break-all;
}
.butSize {
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #0775f1;
	width: 80%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.ui_img {
	width: 75px;
	height: 43px;
}
.buttom_li {
	align-items: end;
}
.guohuibg {
	margin: 0 auto;
	left: 0;
	right: 0;
	position: absolute;
	top: 2vh;
}
.block {
	margin: 0 15px;
	margin-top: -40px;
	padding: 20px 15px;
	border-radius: 4px;
	font-size: 14px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: #fff;
	box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.02);
}
.block-item {
	display: flex;
	column-gap: 4px;
	align-items: center;
	width: 90%;
}
.block-ctx {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.block img {
	width: 50px;
	height: 30px;
}
.bsn {
	font-size: 12px;
	color: #999999;
	text-align: center;
	padding-top: 10px;
}
.tab {
	background-color: #f3f5f4;
	border-radius: 10px 10px 0 0;
}
.tab-box {
	display: flex;
	height: 40px;
}
.tab-box-item {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.tab-box-item-title {
	position: relative;
	z-index: 3;
}
.active {
	/* background-color: #01239d; */
	position: relative;
	font-size: 17px;
	font-weight: 600;
	/* clip-path: polygon(0 0, 90% 0%, 100% 100%, 0 100%); */
	/* clip-path: polygon(0 0, 90% 0%, 100% 100%, 0 100%); */
}
.tab-img {
	height: 40px;
	position: absolute;
	width: 100%;
}
.left {
	height: 45px;
	width: 110%;
	margin-left: 10%;
	margin-bottom: 5px;
}

.right {
	transform: rotateY(180deg);
	height: 45px;
	width: 110%;
	margin-bottom: 5px;
	margin-right: 10%;
}
.center {
	width: 100%;
}
.qrcode {
	display: flex;
	min-height: 300px;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	row-gap: 10px;
}
</style>
